import React, { useState } from 'react'
import styled from 'styled-components'
import {
  useUIFunctions,
  useConfigState,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'

import { Headers, LoginForm, RegisterForm, ForgotPassword } from './Components'
import { Button, Modal, IconChevronRight, Typography } from '../..'


export type AuthPopupProps = { isCheckout?: boolean }

export const AuthPopup = ({ isCheckout }: AuthPopupProps) => {
  const [currentForm, setCurrentForm] = useState<string>('Login')
  const { closeViewById } = useUIFunctions()
  const config = useConfigState()
  const openForm = (form: 'Login' | 'Forgot Password' | 'Register') => () => {
    setCurrentForm(form)
  }

  const labels = useGlobalLabels()

  const handleClose = () => closeViewById(config.views.auth)

  const Forms: { [key: string]: JSX.Element } = {
    Login: (
      <LoginForm
        handleClose={handleClose}
        openForgotPassword={openForm('Forgot Password')}
      />
    ),
    Register: <RegisterForm handleClose={handleClose} />,
    'Forgot Password': (
      <ForgotPassword handleClose={handleClose} goBack={openForm('Login')} />
    ),
  }

  return (
    <Modal
      fullOnMobile
      withBottomOffset
      maxWidth="45rem"
      {...{ open: true, handleClose }}
    >
      {currentForm !== 'Forgot Password' && isCheckout && (
        <AllowGuestContainer>
          <AllowGuestLabel onClick={() => setCurrentForm('Register')}>
            {labels?.notRegistered}
          </AllowGuestLabel>
          <Button
            bordered
            fullWidth
            small
            type="button"
            variant="lightgrey"
            icon={<StyledIconRight />}
            iconPosition="right"
            link="/checkout"
            onClick={handleClose}
          >
            <Typography variant="5">{labels?.continueAsGuest}</Typography>
          </Button>
        </AllowGuestContainer>
      )}
      {currentForm !== 'Forgot Password' && (
        <Headers active={currentForm} setActive={setCurrentForm} />
      )}

      {Forms[currentForm]}
    </Modal>
  )
}

const AllowGuestContainer = styled.div.attrs({
  className: 'mb-5 pb-3',
})`
  color: ${({ theme }) => theme.palette.silverTree};
  text-align: center;
  font-size: 1.7rem;
  font-weight: 600;
`

const AllowGuestLabel = styled(Typography).attrs({
  variant: '5',
  className: 'mb-5',
})`
  color: ${({ theme }) => theme.palette.primary};
  text-decoration: underline;
  cursor: pointer;
  font-weight: 400;
  text-align: center;
`
const StyledIconRight = styled(IconChevronRight)`
  width: 1.4rem;
  color: ${({ theme }) => theme.palette.primary};
  margin-top: -0.7rem;
`
